//--------------------------------OTEHRS---------------------------------------
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const UPDATE_SELECTED_DEVICE_SWITCHLIST = "UPDATE_SELECTED_DEVICE_SWITCHLIST";
export const UPDATE_SWITCH_DETAILS = "UPDATE_SWITCH_DETAILS";

//-----------------------------TRANSFER DEVICE-------------------------------------
export const SET_CURRENT_USER_UNASSIGNED_DEVICE_LIST_ASYNC = "SET_CURRENT_USER_UNASSIGNED_DEVICE_LIST_ASYNC";

//-----------------------------DEVICE LIST-------------------------------------
export const CLEAR_DEVICE_ERROR = "CLEAR_DEVICE_ERROR";
export const SET_DEVICES_PENDING = "SET_DEVICES_PENDING";
export const SET_DEVICES_LIST = "SET_DEVICES_LIST";
export const CLEAR__DEVICE_LIST_ERROR = "CLEAR__DEVICE_LIST_ERROR";
export const DEVICES_LIST_ERROR = "DEVICES_LIST_ERROR"

//-----------------------------DEVICE LOG--------------------------------------
export const OPEN_DEVICE_LOG_MODAL = "OPEN_DEVICE_LOG_MODAL";
export const GET_DEVICE_LOG_PENDING = "GET_DEVICE_LOG_PENDING";
export const CLOSE_DEVICE_LOG_MODAL = "CLOSE_DEVICE_LOG_MODAL";
export const SET_DEVICE_LOG = "SET_DEVICE_LOG";
export const CLEAR_DEVICE_LOG = "CLEAR_DEVICE_LOG";
export const DEVICE_LOG_ERROR = "DEVICE_LOG_ERROR";
export const GET_DEVICE_LOG_SUCCESS = "GET_DEVICE_LOG_SUCCESS";
export const SET_SELECTED_DEVICE = "SET_SELECTED_DEVICE";

//-----------------------------DEVICE LIFE CYCLE-------------------------------
export const OPEN_DEVICE_CYCLE_MODAL = "OPEN_DEVICE_CYCLE_MODAL";
export const CLOSE_DEVICE_CYCLE_MODAL = "CLOSE_DEVICE_CYCLE_MODAL";
export const SET_DEVICE_CYCLE_INITIAL_STATE = "SET_DEVICE_CYCLE_INITIAL_STATE";
export const GET_DEVICE_CYCLE_PENDING = "GET_DEVICE_CYCLE_PENDING";
export const SET_DEVICE_CYCLE = "SET_DEVICE_CYCLE";
export const GET_DEVICE_CYCLE_SUCCESS = "GET_DEVICE_CYCLE_SUCCESS";
export const DEVICE_CYCLE_ERROR = "DEVICE_CYCLE_ERROR";
export const SET_SELECTED_DEVICE_ID = "SET_SELECTED_DEVICE_ID";

//-----------------------------DEVICE CREATE-----------------------------------
export const OPEN_CREATE_DEVICE_MODAL = "OPEN_CREATE_DEVICE_MODAL";
export const CLOSE_CREATE_DEVICE_MODAL = "CLOSE_CREATE_DEVICE_MODAL";
export const CREATE_DEVICE_PENDING = "CREATE_DEVICE_PENDING";
export const CREATE_DEVICE_SUCCESS = "CREATE_DEVICE_SUCCESS";
export const CREATE_DEVICE_ERROR = "CREATE_DEVICE_ERROR";
export const CLEAR_CREATE_DEVICE_ERROR = "CLEAR_CREATE_DEVICE_ERROR";
export const ADD_DEVICE_FORM = "ADD_DEVICE_FORM "

//-----------------------------DEVICE EDIT-------------------------------------
export const CLOSE_EDIT_DEVICE_MODAL = "CLOSE_EDIT_DEVICE_MODAL";
export const OPEN_EDIT_DEVICE_MODAL = "OPEN_EDIT_DEVICE_MODAL";
export const CLEAR_UPDATE_DEVICE_ERROR = "CLEAR_UPDATE_DEVICE_ERROR";
export const UPDATE_DEVICE_PENDING = "UPDATE_DEVICE_PENDING";
export const UPDATE_DEVICE_SUCCESS = "UPDATE_DEVICE_SUCCESS";
export const UPDATE_DEVICE_ERROR = "UPDATE_DEVICE_ERROR";

//-----------------------------DEVICE ASSIGN-----------------------------------
export const OPEN_ASSIGN_DEVICE_MODAL = "OPEN_ASSIGN_DEVICE_MODAL";
export const CLOSE_ASSIGN_DEVICE_MODAL = "CLOSE_ASSIGN_DEVICE_MODAL";
export const ASSIGN_DEVICE_PENDING = "ASSIGN_DEVICE_PENDING";
export const ASSIGN_DEVICE_SUCCESS = "ASSIGN_DEVICE_SUCCESS";
export const ASSIGN_DEVICE_ERROR = "ASSIGN_DEVICE_ERROR";
export const CLEAR_ASSIGN_DEVICE_ERROR = "CLEAR_ASSIGN_DEVICE_ERROR";
export const SET_ASSIGN_DEVICE = "SET_ASSIGN_DEVICE"

//-----------------------------DEVICE DELETE-----------------------------------
export const DEVICE_DELETE_CONFIRMATION_OPEN = "DEVICE_DELETE_CONFIRMATION_OPEN";
export const DEVICE_DELETE_CONFIRMATION_CLOSE = "DEVICE_DELETE_CONFIRMATION_CLOSE";
export const SET_DEVICE_DELETE_DATA = "SET_DEVICE_DELETE_DATA";
export const SET_DEVICE_DELETE_PENDING = "SET_DEVICE_DELETE_PENDING";
export const DEVICE_DELETE_ERROR = "DEVICE_DELETE_ERROR";
export const CLEAR__DEVICE_DELETE_ERROR = "CLEAR__DEVICE_DELETE_ERROR";

//-----------------------------MASTER DEVICE LIST-----------------------------------
export const SET_MASTER_DEVICES_PENDING = "SET_MASTER_DEVICES_PENDING";
export const SET_MASTER_DEVICES_LIST = "SET_MASTER_DEVICES_LIST";
export const MASTER_DEVICES_LIST_ERROR = "MASTER_DEVICES_LIST_ERROR"

//-----------------------------MASTER DEVICE DETAILS--------------------------------
export const GET_MASTER_DEVICE_DETAILS_PENDING = "GET_MASTER_DEVICE_DETAILS_PENDING";
export const SET_MASTER_DEVICE_DETAILS = "SET_MASTER_DEVICE_DETAILS";
export const GET_MASTER_DEVICE_DETAILS_SUCCESS = "GET_MASTER_DEVICE_DETAILS_SUCCESS";

//-----------------------------MASTER DEVICE CREATE---------------------------------
export const ADD_MASTER_DEVICE_FORM = "ADD_MASTER_DEVICE_FORM"
export const SET_MASTER_DEVICE_KEY = "SET_MASTER_DEVICE_KEY";
export const OPEN_CREATE_MASTER_DEVICE_MODAL = "OPEN_CREATE_MASTER_DEVICE_MODAL";
export const CLOSE_CREATE_MASTER_DEVICE_MODAL = "CLOSE_CREATE_MASTER_DEVICE_MODAL";
export const CREATE_MASTER_DEVICE_PENDING = "CREATE_MASTER_DEVICE_PENDING";
export const CREATE_MASTER_DEVICE_SUCCESS = "CREATE_MASTER_DEVICE_SUCCESS";
export const CREATE_MASTER_DEVICE_ERROR = "CREATE_MASTER_DEVICE_ERROR";
export const CLEAR_CREATE_MASTER_DEVICE_ERROR = "CLEAR_CREATE_MASTER_DEVICE_ERROR";
export const SET_DEVICE_LIST_OPTION = "SET_DEVICE_LIST_OPTION"
export const SET_UNASSIGNED_DEVICE_LIST_ASYNC = "SET_UNASSIGNED_DEVICE_LIST_ASYNC";

//-----------------------------MASTER DEVICE EDIT-----------------------------------
export const CLOSE_EDIT_MASTER_DEVICE_MODAL = "CLOSE_EDIT_MASTER_DEVICE_MODAL";
export const OPEN_EDIT_MASTER_DEVICE_MODAL = "OPEN_EDIT_MASTER_DEVICE_MODAL";
export const CLEAR_UPDATE_MASTER_DEVICE_ERROR = "CLEAR_UPDATE_MASTER_DEVICE_ERROR";
export const UPDATE_MASTER_DEVICE_PENDING = "UPDATE_MASTER_DEVICE_PENDING";
export const UPDATE_MASTER_DEVICE_SUCCESS = "UPDATE_MASTER_DEVICE_SUCCESS";
export const UPDATE_MASTER_DEVICE_ERROR = "UPDATE_MASTER_DEVICE_ERROR";

//-----------------------------MASTER DEVICE MAPPING-----------------------------------
export const OPEN_MAP_NEW_DEVICE_MODAL = "OPEN_MAP_NEW_DEVICE_MODAL";
export const CLOSE_MAP_NEW_DEVICE_MODAL = "CLOSE_MAP_NEW_DEVICE_MODAL";
export const CLEAR_MAP_NEW_DEVICE_ERROR = "CLEAR_MAP_NEW_DEVICE_ERROR";
export const MAP_NEW_DEVICE_PENDING = "MAP_NEW_DEVICE_PENDING";
export const MAP_NEW_DEVICE_SUCCESS = "MAP_NEW_DEVICE_SUCCESS";
export const MAP_NEW_DEVICE_ERROR = "MAP_NEW_DEVICE_ERROR";

//-----------------------------ROOM EDIT-----------------------------------------------
export const CLOSE_UPDATE_ROOM_DETAILS_MODAL = "CLOSE_UPDATE_ROOM_DETAILS_MODAL";
export const OPEN_UPDATE_ROOM_DETAILS_MODAL = "OPEN_UPDATE_ROOM_DETAILS_MODAL";
export const CLEAR_UPDATE_ROOM_DETAILS_ERROR = "CLEAR_UPDATE_ROOM_DETAILS_ERROR";
export const UPDATE_ROOM_DETAILS_PENDING = "UPDATE_ROOM_DETAILS_PENDING";
export const UPDATE_ROOM_DETAILS_SUCCESS = "UPDATE_ROOM_DETAILS_SUCCESS";
export const UPDATE_ROOM_DETAILS_ERROR = "UPDATE_ROOM_DETAILS_ERROR";
export const SET_UNASSIGNABLE_GROUPS_LIST_ASYNC = "SET_UNASSIGNABLE_GROUPS_LIST_ASYNC";
export const SET_LAST_SERIAL_NO = "SET_LAST_SERIAL_NO";

//-----------------------------GROUP CREATE---------------------------------------------
export const OPEN_CREATE_GROUP_MODAL = "OPEN_CREATE_GROUP_MODAL";
export const CLOSE_CREATE_GROUP_MODAL = "CLOSE_CREATE_GROUP_MODAL";
export const CLEAR_CREATE_GROUP_ERROR = "CLEAR_CREATE_GROUP_ERROR";
export const CREATE_GROUP_PENDING = "CREATE_GROUP_PENDING";
export const CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export const CREATE_GROUP_ERROR = "CREATE_GROUP_ERROR";

//-----------------------------GROUP EDIT-----------------------------------------------
export const OPEN_UPDATE_GROUP_MODAL = "OPEN_UPDATE_GROUP_MODAL";
export const CLOSE_UPDATE_GROUP_MODAL = "CLOSE_UPDATE_GROUP_MODAL";
export const CLEAR_UPDATE_GROUP_ERROR = "CLEAR_UPDATE_GROUP_ERROR";
export const UPDATE_GROUP_PENDING = "UPDATE_GROUP_PENDING";
export const UPDATE_GROUP_SUCCESS = "UPDATE_GROUP_SUCCESS";
export const UPDATE_GROUP_ERROR = "UPDATE_GROUP_ERROR";

//----------------------------DEVICE CREATE VALUES---------------------------------------
export const NO_OF_SWITCHES = 16;
export const DEFAULT_MASTER_DEVICE_SERIAL_NO = '0001';

export const ASSIGNED_STATUS_LIST = [
  { label: "All", value: undefined, },
  { label: "Assigned", value: true, },
  { label: "Unassigned", value: false, },
];
export const RETURNED_STATUS_LIST = [
  { label: "All", value: undefined, },
  { label: "Returned", value: true, },
  { label: "New", value: false, },
];
export const DELETED_STATUS_LIST = [
  { label: "All", value: undefined, },
  { label: "Deleted", value: true, },
  { label: "Available", value: false, },
];

export const STATUS_LIST = [
  { label: "All", value: undefined, },
  { label: "Active", value: true, },
  { label: "Inactive", value: false, },
];

export const ENABLED_STATUS_LIST = [
  { label: "All", value: undefined, },
  { label: "Enabled", value: true, },
  { label: "Disabled", value: false, },
];
export const AMC_STATUS_OPTIONS = [
  { label: "In Progress", value: "inProgress", },
];

//----------------------------DEVICE EXPORT HEADERS---------------------------------------
export const DEVICE_EXPORT_HEADERS = [
  "SERIAL NUMBER",
  "UID",
  "MODEL NUMBER",
  "NAME",
  "DEVICE CATEGORY",
  "H/W VER",
  "F/W VER",
  "ORGANIZATION",
  "CREATED DATE",
  "ASSIGNED BY USER",
  "ASSIGNED BY USER EMAIL",
  "ASSIGNED TO USER",
  "ASSIGNED TO USER EMAIL",
  "ASSIGNED TO USER ROLE",
  "ASSIGN STATUS",
  "ACTIVE STATUS",
  "DELETED STATUS",
  "ROOM NAME",
  "CUSTOMER NAME",
  "CUSTOMER EMAIL",
  "SUBSCRIPTION VALIDITY",
  "AMC START DATE",
  "AMC END DATE",
  "AMC STATUS",

];

export const MASTER_DEVICE_EXPORT_HEADERS = [
  "UID",
  "FRIENDLY NAME",
  "STATUS",
  "DEVICES",
  "ASSIGNED BY USERNAME",
  "ASSIGNED BY USER EMAIL",
  "CUSTOMER NAME",
  "CUSTOMER EMAIL",
  "CUSTOMER ZONE",
  "CUSTOMER ZIP",
  "VALIDITY",
  "CREATED DATE",
];